var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.2 2.6A2.2 2.2 0 0 1 2.4.4h13.2a2.2 2.2 0 0 1 2.2 2.2v2.2a2.2 2.2 0 0 0 0 4.4v2.2a2.2 2.2 0 0 1-2.2 2.2H2.4a2.2 2.2 0 0 1-2.2-2.2V9.2a2.2 2.2 0 1 0 0-4.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.921cb0148f7868e60ee15a5390e240af.svg";
export { ForwardRef as ReactComponent };